import { Component, OnInit } from '@angular/core';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-remboursement-capital-deces',
  templateUrl: './remboursement-capital-deces.component.html',
  styleUrls: ['./remboursement-capital-deces.component.scss']
})
export class RemboursementCapitalDecesComponent implements OnInit {

  FILE_MAX_SIZE = this.configurationService.get().FILE.FILE_MAX_SIZE;
  MESSAGE_REQUIRED = this.configurationService.get().FILE.MESSAGE_REQUIRED;
  FILE_ACCEPT_TYPE = this.configurationService.get().FILE.FILE_ACCEPT;
  FILE_LIMIT = this.configurationService.get().FILE.FILE_LIMIT;
  IS_MULTIPLE = this.configurationService.get().FILE.MULTIPLE;
  configuration= this.configurationService.get();
  fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
